var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgHome24 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2,
    d: "m13.06 2.412 7.851 7.134a1.57 1.57 0 0 1 .51 1.158v9.077a1.58 1.58 0 0 1-.824 1.383 1.53 1.53 0 0 1-.746.187h-4.07a.785.785 0 0 1-.786-.785v-3.64a2.855 2.855 0 1 0-5.71 0v3.64a.785.785 0 0 1-.785.785H4.15a1.561 1.561 0 0 1-1.177-.53 1.61 1.61 0 0 1-.393-1.08v-9.037a1.57 1.57 0 0 1 .51-1.158l7.851-7.134a1.57 1.57 0 0 1 2.12 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
});
SvgHome24.displayName = "SvgHome24";
export default SvgHome24;